// components/About.jsx
import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-2">About Me</h2>
          <div className="w-24 h-1 bg-primary mx-auto"></div>
        </motion.div>
        
        <div className="flex flex-col md:flex-row items-center">
          <motion.div 
            className="md:w-1/2 mb-8 md:mb-0"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-gradient-to-br from-primary to-accent rounded-lg p-1">
              <div className="bg-white rounded-lg p-6">
                <p className="text-lg leading-relaxed text-gray-700">
                  I am a motivated and detail-oriented Software Engineering undergraduate with a strong passion for learning and problem-solving. 
                  Skilled in collaborating within team environments to achieve shared goals, I bring a proactive and 
                  adaptable approach to tasks.
                </p>
                <p className="text-lg leading-relaxed text-gray-700 mt-4">
                  Committed to personal and professional growth, I excel in leveraging opportunities to contribute 
                  effectively to projects, ensuring quality and innovation in every endeavor.
                </p>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="md:w-1/2 md:pl-12"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold mb-6 text-primary">Personal Details</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="min-w-24 font-semibold">Name:</div>
                <div>Dulani Kariyawasam</div>
              </div>
              <div className="flex items-start">
                <div className="min-w-24 font-semibold">Location:</div>
                <div>No,105, Kebellahena Halthota</div>
              </div>
              <div className="flex items-start">
                <div className="min-w-24 font-semibold">Email:</div>
                <div>hansamalidulani6678@gmail.com</div>
              </div>
              <div className="flex items-start">
                <div className="min-w-24 font-semibold">Phone:</div>
                <div>+94-789960694</div>
              </div>
              <div className="flex items-start">
                <div className="min-w-24 font-semibold">Languages:</div>
                <div>English (Professional Proficiency), Sinhala (Native)</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;